import * as React from "react";
import {FilterComponent} from "./FilterComponent";
import {FieldFacets} from "../../api";
import iconSlider from "../../assets/icons/slider.svg";
import SidebarArea from "./SidebarArea";
import {FieldHelper} from "../utils/FieldHelper";

interface IFilterArea {
    facets?: Array<FieldFacets>;
}

export const FilterArea: React.FC<IFilterArea> = ({ facets = [] }) => {

    function sortFacets(facets: Array<FieldFacets>): Array<FieldFacets> {
        return facets.sort((a, b) =>
            FieldHelper.getFieldOrderSortResult(a.id, b.id)
        );
    }

    function renderFilters() {
        return sortFacets(facets).map((filter) => {
            return <FilterComponent fieldFacets={filter} key={filter.id} />;
        });
    }

    return (
        <SidebarArea icon={iconSlider} title="Filter" show={true}>
            {renderFilters()}
        </SidebarArea>
    );
};

export default FilterArea;
